/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Lot_History_Type_InInputs */

const vi_sl_lot_history_type_in = /** @type {(inputs: Sl_Lot_History_Type_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập`)
};

/**

* @param {Sl_Lot_History_Type_InInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_lot_history_type_in = /** @type {((inputs?: Sl_Lot_History_Type_InInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Lot_History_Type_InInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_lot_history_type_in(inputs)
});